import type {
  ForecastCapacityApiData,
  ForecastCapacityApiResponses,
  ForecastDayDetailsApiData,
  ForecastDayDetailsApiResponses,
  ForecastGrowthApiData,
  ForecastGrowthApiResponses,
  ForecastOverviewApiData,
  ForecastOverviewApiResponses,
  ForecastScenariosApiData,
  ForecastScenariosApiResponses,
  ForecastSeasonsApiData,
  ForecastSeasonsApiResponses,
  ForecastVolumeApiData,
  ForecastVolumeApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
export const getForecastUrls = {
  getForecastOverview: dataEndpoint<ForecastOverviewApiData, ForecastOverviewApiResponses>({
    getUrl: ({ serviceDepartmentId, ...query }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/forecast/overview/`, query)
  }),
  getForecastGrowth: dataEndpoint<ForecastGrowthApiData, ForecastGrowthApiResponses>({
    getUrl: ({ serviceDepartmentId, ...query }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/forecast/growth/`, query)
  }),
  getForecastVolume: dataEndpoint<ForecastVolumeApiData, ForecastVolumeApiResponses>({
    getUrl: ({ serviceDepartmentId, ...query }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/forecast/volume/`, query)
  }),
  getForecastCapacity: dataEndpoint<ForecastCapacityApiData, ForecastCapacityApiResponses>({
    getUrl: ({ serviceDepartmentId, ...query }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/forecast/capacity/`, query)
  }),
  getForecastDayDetails: dataEndpoint<ForecastDayDetailsApiData, ForecastDayDetailsApiResponses>({
    getUrl: ({ serviceDepartmentId, ...query }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/forecast/day-details/`, query)
  }),
  postForecastScenarios: responseEndpoint<ForecastScenariosApiData, ForecastScenariosApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/forecast/scenarios/`),
    getBody: (data) => data
  }),
  getForecastSeasons: dataEndpoint<ForecastSeasonsApiData, ForecastSeasonsApiResponses>({
    getUrl: ({ serviceDepartmentId, ...query }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/forecast/seasons/`, query)
  })
};
